import { createSelector } from '../lib/createSelector';
import { aggregateMetricsByType } from './lib/aggregateMetricsByType';

export const operationsMetrics = (state) => state.operations.operationsMetrics;
export const companiesWithWorkflows = (state) => state.operations.companiesWithWorkflows;
export const workflowAlarms = (state) => state.operations.workflowAlarms;
export const hubspotCompanyMappings = (state) => state.operations.hubspotCompanyMappings;
export const hubspotCompanyMappingsError = (state) => state.operations.hubspotCompanyMappingsError;
export const alarmEnabledWorkflowIds = createSelector(
  //
  'alarmEnabledWorkflowIds',
  [workflowAlarms],
  (alarms) => new Set((alarms || []).map((alarm) => alarm.workflowId))
);
export const operationMetricsWithCompany = createSelector(
  //
  'operationMetricsWithCompany',
  [operationsMetrics, companiesWithWorkflows],
  (metrics, companies) => {
    return metrics.map((metric) => {
      const company = companies.find((c) => c.companyId === metric.companyId);
      const workflow = company ? company.workflows.find((w) => w.id === metric.workflowId) : null;
      return {
        ...metric,
        operationsEngineers: company ? company.operationsEngineers : [],
        companyName: company ? company.companyName : '',
        workflowName: workflow ? workflow.name : ''
      };
    });
  }
);

export const operationsMetricsByEngineer = createSelector(
  //
  'operationsMetricsByEngineer',
  [operationMetricsWithCompany],
  (metrics) => {
    return aggregateMetricsByType(metrics || [], 'operationsEngineers');
  }
);

export const operationsMetricsByCompany = createSelector(
  'operationsMetricsByCompany',
  [operationMetricsWithCompany, (_, engineerId) => engineerId], //
  (metrics, engineerId) => {
    const filteredMetrics = metrics.filter((metric) => metric.operationsEngineers.includes(engineerId));
    return aggregateMetricsByType(filteredMetrics, 'companyId', ['companyName']);
  }
);
